import React from 'react'
import { Route } from 'react-router'

import { DEBUG } from 'containers/App/constants'
import { ButtonsPreviewLoadable } from 'dev/ButtonsPreview/Loadable'
import { DialogsPreviewLoadable } from 'dev/DialogsPreview/Loadable'
import { FormPreviewLoadable } from 'dev/FormPreview/Loadable'
import IconsLoadable from 'dev/IconsPreview/Loadable'

import { DevMenu } from './DevMenu'

export function DevRoutes() {
  if (!DEBUG) {
    return null
  }

  return (
    <>
      <DevMenu />

      <Route
        path="/dev/icons"
        component={IconsLoadable}
      />
      <Route
        path="/dev/buttons"
        component={ButtonsPreviewLoadable}
      />
      <Route
        path="/dev/dialogs"
        component={DialogsPreviewLoadable}
      />
      <Route
        path="/dev/forms"
        component={FormPreviewLoadable}
      />
    </>
  )
}
